<template>
  <!-- 货源管理 -->
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="提货单号:" prop="billNo">
             <el-input  placeholder="" v-model="searchFrom.billNo"></el-input>
          </el-form-item>
          <el-form-item label="紧急度:" prop="urgentLevel">
            <el-select  v-model="searchFrom.urgentLevel"   placeholder="请选择">
              <el-option v-for="item in jjd" :label="item" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态:" prop="customerStatus">
            <el-select  v-model="searchFrom.customerStatus"   placeholder="请选择">
              <el-option v-for="item in zt" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发货单位:" prop="deliverCompany">
            <el-input  placeholder="" v-model="searchFrom.deliverCompany"></el-input>
          </el-form-item>
          <el-form-item label="收货单位:" prop="receivingCompany">
           <el-input  placeholder="" v-model="searchFrom.receivingCompany"></el-input>
          </el-form-item>
          <el-form-item label="承运企业:" prop="shipmentTenantName">
            <el-input  placeholder="" v-model="searchFrom.shipmentTenantName"></el-input>
          </el-form-item>
           <el-form-item label="委托时间:" prop="createTime">
              <el-date-picker
                v-model="searchFrom.createTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="推送时间:" prop="sendTime">
              <el-date-picker
                v-model="searchFrom.sendTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="指派时间:" prop="appointTime">
              <el-date-picker
                v-model="searchFrom.appointTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="提交时间:" prop="submitTime">
              <el-date-picker
                v-model="searchFrom.submitTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
        </div>
       <div class="searchBtnBox">
         <el-form-item  btnCode="009P001B000"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="009P001B001"  v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" height="100%" style="width: 100%" center>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="紧急度">
          <template slot-scope="scope">
           <span  :class="[{ Bwarning: scope.row.urgentLevel==2 }, { Bsuccess: scope.row.urgentLevel==3 },'urgentLevel']" v-if="scope.row.urgentLevel!=null">{{scope.row.urgentLevel}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="170" >
                <template slot-scope="scope">
                  <el-button type="text" size="mini" btnCode="009P001B002"  v-if="btnFlg[2]" @click="detailFN(scope.row)">详情</el-button>
                  <el-button type="text" size="mini" btnCode="009P001B003"  v-if="btnFlg[3]" v-show="scope.row.customerStatus==0||scope.row.customerStatus==1?true:false"  @click="reasonFN(scope.row)">退回</el-button>
                  <el-button type="text" size="mini" btnCode="009P001B004"  v-if="btnFlg[4]" v-show="scope.row.customerStatus==0||scope.row.customerStatus==1?true:false"  @click="editFN(scope.row)">编辑</el-button>
                  <el-button type="text" size="mini" btnCode="009P001B005"  v-if="btnFlg[5]" v-show="scope.row.customerStatus==4?true:false"  @click="sendFN(scope.row)">推送</el-button>
                  <!-- <el-badge :value="3" class="item" v-if="scope.row.customerStatus==5||scope.row.customerStatus==6?true:false" >
                    <el-button type="text" size="mini" @click="lookFN(scope.row)">查看报价</el-button>
                  </el-badge> -->
                  <el-button type="text" size="mini" btnCode="009P001B006"  v-if="btnFlg[6]" v-show="scope.row.customerStatus==5||scope.row.customerStatus==6?true:false"  @click="lookFN(scope.row)">查看报价</el-button>
                  <el-button type="text" size="mini" btnCode="009P001B007"  v-if="btnFlg[7]" v-show="scope.row.customerStatus==4?true:false" @click="appointFN(scope.row)">指派</el-button>
                  <el-button type="text" size="mini" btnCode="009P001B008"  v-if="btnFlg[8]" v-show="scope.row.customerStatus==6||scope.row.customerStatus==3?false:true" @click="urgentFN(scope.row)">紧急度</el-button>
                </template>
        </el-table-column>
        <el-table-column prop="shipmentTenantName" width="200" label="承运企业"></el-table-column>
        <el-table-column prop="billNo" width="150" label="提货单号"></el-table-column>
         <el-table-column  label="状态" >
          <template scope="scope">
            {{[ "未沟通", "沟通中","已沟通" , "已退回", "待推送", "待指派", "已指派"][scope.row.customerStatus]}}
          </template>
        </el-table-column>
       <el-table-column prop="deliverCompany" width="200" label="发货单位"></el-table-column>
        <el-table-column prop="deliverPerson" width="120"  label="发货人"></el-table-column>
        <el-table-column prop="deliverPhone" width="150"   label="发货人电话"></el-table-column>
        <el-table-column prop="deliverAddress" width="200"  label="提货地址"></el-table-column>
        <el-table-column prop="receivingCompany" width="120"  label="收货单位"></el-table-column>
        <el-table-column prop="receivingPerson" width="120"  label="收货人"></el-table-column>
        <el-table-column prop="receivingPhone" width="150"   label="收货人电话"></el-table-column>
        <el-table-column prop="receivingAddress" width="200"   label="收货地址"></el-table-column>
        <el-table-column prop="allWeight" width="120"   label="总重量（吨）"></el-table-column>
        <el-table-column prop="productNum" width="100"   label="件数"></el-table-column>
        <el-table-column prop="productVolume" width="120"   label="体积"></el-table-column>
         <el-table-column label="计价方式" >
          <template scope="scope">
            {{[ "按吨", "包干" ][scope.row.pricingMethod-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="price" width="120"   label="单价/包干价"></el-table-column>
        <el-table-column prop="storagePrice" width="120"   label="仓储费"></el-table-column>
        <el-table-column prop="allPrice" width="150"   label="合计费用"></el-table-column>
        <el-table-column label="支付方式" >
          <template scope="scope">
            {{[ "电汇", "现金", "其他" ][scope.row.paymentType-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="hopeDeliverDate" :formatter="dateFormat" width="160"   label="期望发货时间"></el-table-column>
        <el-table-column prop="hopeReceivingDate" :formatter="dateFormat" width="160"   label="期望到货时间"></el-table-column>
        <el-table-column prop="remark" width="150"  :show-overflow-tooltip="true"   label="备注"></el-table-column>
       <el-table-column prop="alidDate" width="160" :formatter="dateFormat"  label="有效期至"></el-table-column>
       <el-table-column prop="consultPrice" width="120"   label="参考价"></el-table-column>
        <el-table-column prop="createTime" :formatter="dateFormat" width="160"   label="委托时间"></el-table-column>
        <el-table-column prop="submitTime" :formatter="dateFormat" width="160"   label="提交时间"></el-table-column>
        <el-table-column prop="sendTime" :formatter="dateFormat" width="160"   label="推送时间"></el-table-column>
        <el-table-column prop="appointTime" :formatter="dateFormat" width="160"   label="指派时间"></el-table-column>
        <el-table-column prop="reasonTime" :formatter="dateFormat" width="160"   label="退回时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 退回 -->
    <el-dialog title="退回" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="tuihuiDialog" width="500px" @close="closeDialog" center>
      <span>
         <el-form :inline="true" :model="editFrom" ref="editFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class="inpBox">
               <el-form-item label="退回原因:" prop="storageFee" class="bigInp">
                <el-input  placeholder=""  type="textarea"  maxlength="10"   class="storageFee" v-model="editFrom.checkReason"></el-input>
              </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tuihuiDialog = false">取 消</el-button>
        <el-button type="primary" @click="editSave(3)">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 推送 -->
    <el-dialog title="推送" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="sendDialog" width="500px" @close="closeDialog" center>
      <span>
         <el-form :inline="true" :model="editFrom" ref="editFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="">
               <el-form-item label="参考价:" prop="consultPrice">
                <el-input  placeholder=""   maxlength="10"  v-model="editFrom.consultPrice"></el-input>
              </el-form-item>
               <el-form-item label="有效期至:" prop="validDate">
                <el-date-picker
              v-model="editFrom.validDate"
              format="yyyy-MM-dd HH:mm:ss"
               value-format="timestamp"
              type="datetime"
                placeholder="选择日期时间"
                 :picker-options="pickerOptions"
            ></el-date-picker>
              </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendDialog = false">取 消</el-button>
        <el-button type="primary" @click="editSave(5)">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 紧急度 -->
    <el-dialog title="设置紧急度" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="jinjiDialog" width="500px" @close="closeDialog" center>
      <span>
         <el-form :inline="true" :model="editFrom" ref="editFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class="inpBox">
          <el-form-item label="紧急度:" prop="storageFee" class="bigInp">
            <el-select  v-model="editFrom.urgentLevel"   placeholder="请选择">
              <el-option v-for="item in jjd" :label="item" :value="item" :key="item"></el-option>
            </el-select>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jinjiDialog = false">取 消</el-button>
        <el-button type="primary" @click="urgentSave">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 指派 -->
    <el-dialog title="选择车队" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="xuanzeDialog" width="1100px" @close="closeDialog" center>
      <el-form :inline="true" :model="VsearchFrom" ref="VsearchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="公司名称:" prop="shipmentTenantName">
             <el-input  placeholder="" v-model="VsearchFrom.shipmentTenantName"></el-input>
          </el-form-item>
           <el-form-item>
            <el-button type="primary" @click="VsearchFn">查询</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="resetForm()">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!--  表格 -->
      <el-table :data="VtableList"  ref="table" v-loading="loading"   bordersize="mini"
       highlight-current-row height="400px" style="width: 100%" center>
        <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="80" >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="xuanzeSave(scope.row,1)">指派</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="shipmentTenantName" width="200" :show-overflow-tooltip="true"  label="公司名称"></el-table-column>
       <el-table-column prop="contacts" width="120" label="联系人"></el-table-column>
       <el-table-column prop="telephone" width="150" label="联系电话"></el-table-column>
        <el-table-column prop="address" min-width="200"  label="地址"></el-table-column>
        <el-table-column prop="cooperationNum" width="100" :show-overflow-tooltip="true"  label="合作次数"></el-table-column>
        <el-table-column prop="createTime" width="160" :formatter="dateFormat" label="合作开始时间"></el-table-column>
      </el-table>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="VhandleSizeChange"
        @current-change="VhandleCurrentChange"
        :current-page="VsearchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="VsearchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="Vtotal">
      </el-pagination>
    </div>
    </el-dialog>
     <!-- 查看报价 -->
    <el-dialog title="查看报价" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="lookDialog" width="1100px" @close="closeDialog" center>
      <div style="text-align: right;margin-bottom: 4px;">参考价：{{consultPrice}}元</div>
      <!--  表格 -->
      <el-table :data="offerList"  ref="table" v-loading="loading"   bordersize="mini"
       highlight-current-row height="400px" style="width: 100%" center>
        <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="80" >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="xuanzeSave(scope.row,2)">指派</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="shipmentTenantName" width="200" :show-overflow-tooltip="true"  label="公司名称"></el-table-column>
       <el-table-column prop="shipmentContacts" width="120" label="联系人"></el-table-column>
       <el-table-column prop="shipmentTelephone" width="150" label="联系电话"></el-table-column>
        <el-table-column prop="shipmentAddress" min-width="200"  label="地址"></el-table-column>
        <el-table-column prop="offerPrice" width="100" :show-overflow-tooltip="true"  label="报价"></el-table-column>
        <el-table-column prop="diffPrice" width="100"  label="差价"></el-table-column>
      </el-table>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { KCBlist, KCBupdateStatus, KCClist, KCBupdate, confirmIdentify, KSOlist } from '@/api/soc-customer'
export default {
  data () {
    return {
      h: '500px',
      tuihuiDialog: false,
      jinjiDialog: false,
      xuanzeDialog: false,
      sendDialog: false,
      lookDialog: false,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      VsearchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      Vtotal: 0,
      VtableList: [],
      offerList: [],
      editFrom: {},
      tableList: [],
      consultPrice: [],
      jjd: [1, 2, 3],
      zt: [
        { id: '', name: '全部' },
        { id: 0, name: '未沟通' },
        { id: 1, name: '沟通中' },
        { id: 2, name: '已沟通' },
        { id: 3, name: '已退回' },
        { id: 4, name: '待推送' },
        { id: 5, name: '待指派' },
        { id: 6, name: '已指派' }
      ],
      total: 0,
      sBillId: '',
      kCustomerBillId: '',
      rules: {
        consultPrice: [
          { required: true, message: '请输入参考价', trigger: 'blur' }
        ],
        validDate: [
          { required: true, message: '请选择有效期', trigger: 'blur' }
        ]

      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      loading: 'false',
      btnFlg: [],
      btnIdArr: ['009P001B000', '009P001B001', '009P001B002',
        '009P001B003', '009P001B004', '009P001B005',
        '009P001B006', '009P001B007', '009P001B008']

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/goodsManage')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 详情
    detailFN (row) {
      this.$router.push({ name: 'goodsDetails', query: { id: row.id } })
    },
    // 退回
    reasonFN (row) {
      this.tuihuiDialog = true
      this.kCustomerBillId = row.kCustomerBillId
      this.sBillId = row.id
    },
    // 推送
    sendFN (row) {
      this.sendDialog = true
      this.kCustomerBillId = row.kCustomerBillId
      this.sBillId = row.id
    },
    editSave (n) {
      this.editFrom.sBillId = this.sBillId
      this.editFrom.kCustomerBillId = this.kCustomerBillId
      this.editFrom.customerStatus = n
      if (n == 5) {
        this.$refs.editFrom.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            KCBupdateStatus(this.editFrom).then(res => {
              this.$message({
                message: '推送成功',
                type: 'success'
              })
              loading.close()
              this.sendDialog = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        })
      } else {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        KCBupdateStatus(this.editFrom).then(res => {
          this.$message({
            message: '退回成功',
            type: 'success'
          })
          loading.close()
          this.tuihuiDialog = false
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 编辑
    editFN (row) {
      this.$router.push({ name: 'goodsEdit', query: { id: row.id } })
    },

    // 指派
    appointFN (row) {
      this.VgetList(this.VsearchFrom)
      this.editFrom.billId = row.id
      this.editFrom.kCustomerBillId = row.kCustomerBillId
      this.kCustomerBillId = row.kCustomerBillId
      this.xuanzeDialog = true
    },
    // 查看报价
    lookFN (row) {
      this.editFrom.billId = row.id
      this.editFrom.billNo = row.billNo

      this.editFrom.kCustomerBillId = row.kCustomerBillId
      this.consultPrice = row.consultPrice
      KSOlist(this.editFrom).then(res => {
        this.loading = false
        this.offerList = res
        if (res.length < 1) {
          this.$alert('暂无报价', '系统提示')
        } else {
          this.lookDialog = true
        }
      })
    },
    xuanzeSave (row, n) {
      this.editFrom.flag = n
      if (n == 1) {
        this.editFrom.shipmentTenantId = row.shipmentTenantId
      } else {
        this.editFrom.offerId = row.id
      }

      this.$confirm('是否执行指派操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        confirmIdentify(this.editFrom).then(res => {
          this.$message({
            message: '指派成功',
            type: 'success'
          })
          loading.close()
          this.xuanzeDialog = false
          this.lookDialog = false
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 紧急度
    urgentFN (row) {
      this.jinjiDialog = true
      if (row.urgentLevel) {
        this.editFrom = { urgentLevel: row.urgentLevel }
      } else {
        this.editFrom = { urgentLevel: 3 }
      }
      this.editFrom.id = row.kCustomerBillId
    },
    urgentSave () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      KCBupdate(this.editFrom).then(res => {
        loading.close()
        this.jinjiDialog = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      KCBlist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },

    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 车队查询
    VsearchFn () {
      this.VgetList(this.VsearchFrom)
    },
    // 获取列表
    VgetList (searchFrom) {
      this.loading = true
      KCClist(searchFrom).then(res => {
        this.loading = false
        this.VtableList = res.list
        this.Vtotal = res.total
      })
    },
    // 每页条数
    VhandleSizeChange (val) {
      this.VsearchFrom.pageSize = val
      this.VgetList(this.searchFrom)
    },
    // 当前页
    VhandleCurrentChange (val) {
      this.VsearchFrom.pageNo = val
      this.VgetList(this.VsearchFrom)
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        sendTime: null,
        appointTime: null,
        submitTime: null,
        createTime: null
      }
      this.VsearchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.editFrom = {}
    },
    // 时间格式化
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = ''
      } else {
        str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
  /deep/ .hide .el-upload--picture-card {
  display: none;
}
}
.urgentLevel{
      border: 2px solid #F56C6C;
    border-radius: 50%;
    /* padding: 2px; */
    display: inline-block;
    width: 20px;
    height: 20px;
    line-height: 20px;
}
.Bwarning{
border: 2px solid #E6A23C;
}
.Bsuccess{
border: 2px solid #67C23A;
}
.bigInp /deep/.el-input--mini .el-textarea__inner{
  width:260px;
  height:60px;
}
 /deep/.lookBox .cell{
  overflow: visible;
  display: flex;
  .el-badge{
    margin: 0px 8px;
  }
}
</style>
